import { MessageCircle, FileSearch, RefreshCcw, PartyPopper } from "lucide-react";
import { FadeIn, Eyebrow } from "@/components/Reveal";
import { waLink } from "@/lib/site";
import { trackEvent } from "@/lib/tracking";

const WA_MESSAGE =
    "Olá! Quero trocar de contador e migrar a contabilidade do meu negócio para a Contabeleza.";

const STEPS = [
    {
        icon: MessageCircle,
        title: "Você chama no WhatsApp",
        text: "Contamos como funciona, tiramos suas dúvidas e você autoriza a migração. Simples assim.",
    },
    {
        icon: FileSearch,
        title: "Nós cuidamos da transição",
        text: "Solicitamos os documentos e as pendências à contabilidade anterior, sem desgaste para você.",
    },
    {
        icon: RefreshCcw,
        title: "Sua rotina continua",
        text: "A operação segue rodando normalmente enquanto organizamos tudo do nosso lado.",
    },
];

export default function SwitchAccountant() {
    return (
        <section
            id="trocar-de-contador"
            data-testid="section-switch-accountant"
            aria-labelledby="trocar-contador-titulo"
            className="px-5 py-20 sm:px-8 sm:py-28"
        >
            <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1fr_1.1fr]">
                <FadeIn>
                    <Eyebrow>Migração sem trauma</Eyebrow>
                    <h2
                        id="trocar-contador-titulo"
                        className="mt-4 font-display text-3xl leading-[1.12] tracking-tight text-[#08104F] sm:text-4xl lg:text-5xl"
                    >
                        Quer trocar de contador?
                    </h2>
                    <p className="mt-5 max-w-lg text-base leading-relaxed text-[#3A4768] sm:text-lg">
                        Você pode migrar de contabilidade em qualquer época do ano. A gente cuida de toda a
                        transição com o contador atual, sem interromper a sua operação e sem você precisar
                        resolver nada sozinho.
                    </p>
                    <a
                        href={waLink(WA_MESSAGE, "trocar-de-contador")}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="btn-switch-accountant-whatsapp"
                        onClick={() => trackEvent("whatsapp_click", { location: "switch_accountant" })}
                        className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#08104F] px-7 py-4 text-sm font-semibold text-white transition-all duration-200 hover:bg-[#0047BB] active:scale-[0.97]"
                    >
                        <PartyPopper className="h-4 w-4 text-[#FCB21E]" />
                        Quero trocar de contador
                    </a>
                    <p className="mt-3 text-xs text-[#3A4768]/70">
                        A conversa é sem compromisso e sem contabilês.
                    </p>
                </FadeIn>

                <div className="space-y-4">
                    {STEPS.map((step, i) => (
                        <FadeIn key={step.title} delay={i * 0.1}>
                            <div
                                className={`flex gap-5 rounded-3xl border border-[#08104F]/8 bg-[#FFFDFA] p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(8,16,79,0.10)] sm:p-7 ${
                                    i === 1 ? "lg:ml-10" : i === 2 ? "lg:ml-20" : ""
                                }`}
                            >
                                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#B2D0FF]/30 text-[#0047BB]">
                                    <step.icon className="h-5 w-5" strokeWidth={1.75} />
                                </span>
                                <div>
                                    <p className="font-display text-base text-[#08104F]">
                                        <span className="mr-2 text-[#0047BB]/50">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        {step.title}
                                    </p>
                                    <p className="mt-1.5 text-sm leading-relaxed text-[#3A4768]">{step.text}</p>
                                </div>
                            </div>
                        </FadeIn>
                    ))}
                </div>
            </div>
        </section>
    );
}
